import React from 'react';

import { Form, Radio } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const WithRenderingQuestion = ({ renderingQuestion, hasRenderingQuestion, children }) => {
  return (
    <>
      {hasRenderingQuestion ? (
        <>
          <Form.Item name={'rendering_question_response'} label={renderingQuestion}>
            <Radio.Group>
              <Radio value={true}>{getTranslatedString('renderingQuestion.true')}</Radio>
              <Radio value={false}>{getTranslatedString('renderingQuestion.false')}</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.rendering_question_response !== currentValues.rendering_question_response
            }
          >
            {({ getFieldValue }) =>
              getFieldValue('rendering_question_response') ? children : null
            }
          </Form.Item>
        </>
      ) : (
        children
      )}
    </>
  );
};

export default WithRenderingQuestion;
